import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthUser } from '../login/administrador/AuthUser';
import { UserRole } from '../_models/userEnum';
import { AuthService } from '../_services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
              private authService: AuthService
    
    ) {}

    canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree 
      {
        const currentUser = this.authService.getUser() as AuthUser;

        if (currentUser) {
          // Verifica si el usuario tiene acceso a la ruta solicitada según su rol
          switch (next.data.role) {
            case UserRole.Admin:
              if (currentUser.role === UserRole.Admin) {
                return true;
              }
              break;
            case UserRole.Graduated:
              if (currentUser.role === UserRole.Graduated) {
                return true;
              }
              break;
            case UserRole.Company:
              if (currentUser.role === UserRole.Company) {
                return true;
              }
              break;
            case UserRole.Professor:
                if (currentUser.role === UserRole.Professor) {
                  return true;
                }
                break;
          }
          // Not logged in so redirect to login page with the return url
        }

        

        this.router.navigate(['errors/unauthorized']);
      
    }
}
